import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import '../css/ViewWorkflow.css'; // Assuming this CSS file exists
import '../css/ViewWorkflowModal.css';
import Swal from 'sweetalert2';
import VendorStatus from "./VendorStatus";
import BASE_URL from "./URL";
import CreateWorkflowButton from "./CreateWorkflowButton";
// Define the base API instance
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
if (!API_BASE_URL) throw new Error('API base URL not set. Please set REACT_APP_API_BASE_URL in .env');
const api = axios.create({ baseURL: 'https://django-backend-115705416374.asia-south1.run.app' });
// const api = axios.create({ baseURL: 'http://localhost:8000' });
api.interceptors.request.use(config => {
  const token = localStorage.getItem('access');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const showToast = (icon, title) => {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
            toast.style.backgroundColor = "#83cc85ff"
        },
    });

    Toast.fire({
        icon: icon,
        title: title,
    });
};
api.interceptors.response.use(
  res => res,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refresh = localStorage.getItem('refresh');
      if (refresh) {
        try {
          const res = await axios.post('https://django-backend-115705416374.asia-south1.run.app/api/token/refresh/', { refresh });
          // const res = await axios.post('http://localhost:8000/api/token/refresh/', { refresh });
          localStorage.setItem('access', res.data.access);
          originalRequest.headers.Authorization = `Bearer ${res.data.access}`;
          return api(originalRequest);
        } catch {
          localStorage.removeItem('access');
          localStorage.removeItem('refresh');
          window.location.reload();
        }
      }
    }
    return Promise.reject(error);
  }
);
// --- Inline SVG Icon Components ---
const Pencil = ({ size = 20, className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
    </svg>
);

// --- Edit/Delete Modal Component ---
const EditWorkflowModal = ({ node, onClose, onSave, onDelete }) => {
  const [formData, setFormData] = useState({
    approval_name: node.approval_name,
    approval_email: node.approval_email,
    logic: node.logic,
    link_email: node.link_email || "",
    link_email_2: node.link_email_2 || "",
  });
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    setError(null);
    try {
      await onSave(node.id, formData);
      onClose();
    } catch (err) {
      setError("Failed to save changes.");
      console.error(err);
    } finally {
      setIsSaving(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm(`Are you sure to delete milestone ${node.sequence}?`))
      return;
    setIsDeleting(true);
    try {
      await onDelete(node.id);
      onClose();
    } catch (err) {
      setError("Failed to delete milestone.");
      console.error(err);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="vwm-overlay" onClick={onClose}>
      <div className="vwm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="vwm-header">
          <h2 className="vwm-title">Edit Milestone {node.sequence}</h2>
          <button className="vwm-close" onClick={onClose}>×</button>
        </div>
        <div className="vwm-body">
          {error && <div className="vwm-alert vwm-alert-error">{error}</div>}
          <form onSubmit={handleSave} className="vwm-form">
            <div className="vwm-grid">
              <div className="vwm-field">
                <label className="vwm-label">Milestone Name</label>
                <input type="text" name="approval_name" value={formData.approval_name} onChange={handleChange} className="vwm-input" required readOnly/>
              </div>
              <div className="vwm-field">
                <label className="vwm-label">Approval Logic</label>
                <select name="logic" value={formData.logic} onChange={handleChange} className="vwm-select">
                  <option value="NONE">NONE</option>
                  <option value="AND">AND</option>
                  <option value="OR">OR</option>
                </select>
              </div>
              <div className="vwm-field vwm-col-2">
                <label className="vwm-label">Primary Approver Email</label>
                <input type="email" name="approval_email" value={formData.approval_email} onChange={handleChange} className="vwm-input" required readOnly/>
              </div>
              {formData.logic !== 'NONE' && (
                <div className="vwm-field vwm-col-2">
                  <label className="vwm-label">Secondary Approver Email</label>
                  <input type="email" name="link_email" value={formData.link_email} onChange={handleChange} className="vwm-input" />
                </div>
              )}
              {formData.logic !== 'NONE' && (
                <div className="vwm-field vwm-col-2">
                  <label className="vwm-label">Secondary Approver Email 2</label>
                  <input type="email" name="link_email_2" value={formData.link_email_2} onChange={handleChange} className="vwm-input" />
                </div>
              )}
            </div>
            <div className="vwm-actions">
              <button type="button" className="vwm-btn vwm-btn-danger" onClick={handleDelete} disabled={isDeleting || isSaving}>
                {isDeleting ? 'Deleting...' : 'Delete'}
              </button>
              <div className="vwm-spacer" />
              <button type="button" className="vwm-btn vwm-btn-secondary" onClick={onClose}>Cancel</button>
              <button type="submit" className="vwm-btn vwm-btn-primary" disabled={isSaving || isDeleting}>
                {isSaving ? 'Saving...' : 'Save Changes'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
// Component to display a single milestone step
const WorkflowMilestone = ({ node, onEditClick }) => {
    
    let logicClass = node.logic === 'AND' ? 'logic-and' : node.logic === 'OR' ? 'logic-or' : 'logic-none';

    return (
        <div className="milestone-item">
            <div className="milestone-connector">
                <div className="milestone-number">
                    {node.sequence}
                </div>
                {!node.isLast && <div className="milestone-line"></div>} 
            </div>
            <div className="milestone-card">
                <div className="card-header">
                    <div>
                        <div className="card-title">{node.approval_name}</div>
                        <div className={`logic-tag ${logicClass}`}>
                            Logic: {node.logic}
                        </div>
                        <div className="card-detail">Primary: {node.approval_email}</div>
                        {node.logic !== 'NONE' && (
                            <div className="card-sub-detail">Secondary: {node.link_email || 'N/A'}</div>
                        )}
                        {node.logic !== 'NONE' && (
                            <div className="card-sub-detail">Secondary 2: {node.link_email_2 || 'N/A'}</div>
                        )}
                    </div>
                    
                    <button 
                        className="btn-edit"
                        aria-label={`Edit ${node.approval_name}`}
                        onClick={() => onEditClick(node)}
                    >
                        <Pencil size={20} />
                    </button>
                </div>
            </div>
        </div>
    );
};


const ViewWorkflow = () => {
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState('');
    const [workflow, setWorkflow] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [nodeToEdit, setNodeToEdit] = useState(null);

    // Function to fetch workflow (reused for initial load and refresh)
    const fetchWorkflow = useCallback(async (company) => {
        setIsLoading(true);
        setError(null);
        setWorkflow(null);
        try {
            // Note: Backend must return the database 'id'
            const response = await api.get(`api/viewworkflow/?company=${company}`);
            
            if (response.data.workflow) {
                const structuredWorkflow = response.data.workflow.map((node, index, arr) => ({
                    ...node,
                    isLast: index === arr.length - 1
                }));
                
                setWorkflow(structuredWorkflow);
            } else {
                setWorkflow([]);
            }
            
        } catch (err) {
            console.error("Error fetching workflow:", err);
            setError("Error fetching workflow data. Please try again.");
            setWorkflow(null);
        } finally {
            setIsLoading(false);
        }
    }, []);


    // 1. Fetch all unique company names on component load
    useEffect(() => {
        const fetchCompanies = async () => {
            try {
                const response = await api.get('api/viewworkflow/');
                
                const trimmedCompanies = (response.data.companies || []).map(c => c.trim());
                const uniqueCompanies = Array.from(new Set(trimmedCompanies));
                
                setCompanies(uniqueCompanies);
                setError(null);
            } catch (err) {
                console.error("Error fetching companies:", err);
                setError("Could not load company list. Check backend connectivity.");
            }
        };
        fetchCompanies();
    }, []);

    // 2. Fetch workflow for the selected company
    const handleSearch = useCallback(() => {
        if (!selectedCompany) {
            setWorkflow(null);
            setError("Please select a company.");
            return;
        }
        fetchWorkflow(selectedCompany);
    }, [selectedCompany, fetchWorkflow]);


    // --- Handlers for Modal and CRUD operations ---
    const handleEditClick = (node) => {
        setNodeToEdit(node);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setNodeToEdit(null);
    };

    // 💾 API CALL TO UPDATE (SAVE)
    const handleSaveNode = async (nodeId, updatedData) => {
      console.log(updatedData)
        const payload = {
            ...updatedData,
            company: selectedCompany 
        };
        
        // Ensures the PUT request is sent to the correct endpoint
         try {
            const normalized = {
              ...payload,
              approval_email: (payload.approval_email || '').trim(),
              link_email: (payload.link_email || '').trim(),
              link_email_2: (payload.link_email_2 || '').trim(),
              logic: (payload.logic || 'NONE').toUpperCase(),
            };
            await api.put(`workflow/update/${nodeId}/`, normalized);
            await fetchWorkflow(selectedCompany);
            showToast('success', 'Milestone updated successfully!'); // SUCCESS TOAST
        } catch (err) {
            console.error(err);
            showToast('error', 'Failed to save changes.'); // ERROR TOAST
            throw err; // Re-throw the error to be caught by the modal's catch block
        }
    };

    // 🗑️ API CALL TO DELETE
    const handleDeleteNode = async (nodeId) => {
        // Ensures the DELETE request is sent to the correct endpoint
        await api.delete(`workflow/delete/${nodeId}/`);
        
        // Refresh the workflow list
        await fetchWorkflow(selectedCompany);
    };


    return (
        <div className="workflow-container">
            <h3 className="workflow-title">View Workflow Milestones</h3>
            
            <div className="search-controls">
                <label htmlFor="company-select">Select Company:</label>
                <select
                    id="company-select"
                    value={selectedCompany}
                    onChange={(e) => setSelectedCompany(e.target.value)}
                    className="company-select"
                >
                    <option value="">-- Choose a Company --</option>
                    {companies.map((company) => (
                        <option key={company} value={company}>{company}</option>
                    ))}
                </select>
                <button
                    onClick={handleSearch}
                    disabled={!selectedCompany || isLoading}
                    className="btn-search"
                >
                    {isLoading ? 'Searching...' : 'Search Workflow'}
                </button>
                
            </div>
                    
            {error && <div className="error-message">{error}</div>}
            
            {workflow && (
                <div className="workflow-display">
                    <h4 className="workflow-subtitle">Workflow for: {selectedCompany}</h4>
                    {workflow.length > 0 ? (
                        <div className="milestone-list">
                            {workflow.map((node) => (
                                <WorkflowMilestone 
                                    key={node.id} // ✅ FIX: Using the stable database ID as the key
                                    node={node}
                                    onEditClick={handleEditClick}
                                />
                            ))}
                            {/* Final Step Indicator */}
                            <div className="workflow-end">
                                <div className="end-dot"></div>
                                <div className="end-text">Workflow Ends</div>
                            </div>
                        </div>
                    ) : (
                        <div className="empty-state">
                            No workflow steps found for this company.
                        </div>
                    )}
                </div>
            )}

            {/* Modal for Editing */}
            {isModalOpen && nodeToEdit && (
                <EditWorkflowModal 
                    node={nodeToEdit}
                    onClose={handleCloseModal}
                    onSave={handleSaveNode} // Passed to modal for PUT call
                    onDelete={handleDeleteNode} // Passed to modal for DELETE call
                />
            )}
        </div>
    );
};

export default ViewWorkflow;